<button [type]="type" [disabled]="disabled" [ngStyle]="{'pointer-events-none': disabled}" mat-flat-button color="primary">
  <ng-content></ng-content>
</button>
